
import { Component, Vue, Prop } from "vue-property-decorator";
import { City } from "@/models/City";
import { Game } from "@/models/Game";

import { Quests } from "@/models/MapPois/Quest/Quests";

import { cloneDeep, isEqual } from "lodash";
import SavePanel from "../Base/SavePanel.vue";
import QuestErrors from "./ComposeTabs/ComposeQuestItems/QuestErrors.vue";
import QuestGeneral from "./ComposeTabs/ComposeQuestItems/QuestGeneral.vue";
import QuestStatusActive from "./ComposeTabs/ComposeQuestItems/QuestStatusActive.vue";
import QuestStatusCancelled from "./ComposeTabs/ComposeQuestItems/QuestStatusCancelled.vue";
import QuestStatusComplete from "./ComposeTabs/ComposeQuestItems/QuestStatusComplete.vue";
import QuestStatusFinal from "./ComposeTabs/ComposeQuestItems/QuestStatusFinal.vue";
import QuestStatusFailed from "./ComposeTabs/ComposeQuestItems/QuestStatusFailed.vue";
import QuestStatusNone from "./ComposeTabs/ComposeQuestItems/QuestStatusNone.vue";
import QuestStatusUnlocked from "./ComposeTabs/ComposeQuestItems/QuestStatusUnlocked.vue";
import LanguageSelectCard from "../Base/LanguageSelectCard.vue";
import QuestMapErrors from "@/utils/ErrorQuest/QuestMapErrors";
import QuestWarningErrors from "@/utils/ErrorQuest/QuestMapWarning";

@Component({
  components: {
    SavePanel,
    QuestErrors,
    QuestGeneral,
    QuestStatusNone,
    QuestStatusUnlocked,
    QuestStatusActive,
    QuestStatusComplete,
    QuestStatusFailed,
    QuestStatusCancelled,
    QuestStatusFinal,
    LanguageSelectCard,
  },
})
class EditQuest extends Vue {
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: null }) readonly questKey!: string;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: null }) readonly gameUid!: string;
  showSavePanel = false;
  isSavedOrDiscard = false;
  mapPoiKey = "";
  tabPicked = 1;
  questDataObject = {} as Quests;
  showPoi = false;
  test = "test";

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }
  get showButton(): boolean {
    return true;
  }
  get getQuestData(): Quests {
    return this.$store.state.questStore.quest.filter(
      (x: Quests) => x.key === this.questKey
    )[0];
  }

  get getGame(): Game {
    return this.$store.state.gameStore.games.find(
      (x: Game) => x.key == this.gameUid
    );
  }

  get getTabbedPicked(): number {
    return this.tabPicked;
  }
  created(): void {
    this.questDataObject = cloneDeep(this.getQuestData);
    this.$nextTick(function() {
      this.$bvModal.show("team-modal-edit-poi");
    });
  }

  updateTempObject(questData: Quests): void {
    this.questDataObject = cloneDeep(questData);
    this.isSavedOrDiscard = false;
    if (!isEqual(this.questDataObject, this.getQuestData)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
  }
  handleSubmitPressed(): void {
    this.showPoi = true;
  }
  closeDialog(): void {
    this.showPoi = false;
    this.handleClose();
  }

  handleClose(): void {
    this.$bvModal.hide("team-modal-edit-poi");
    this.$emit("closeEditPoi");
  }

  discardChanges(value: boolean): void {
    this.questDataObject = cloneDeep(this.getQuestData);
    this.showSavePanel = false;
    this.isSavedOrDiscard = true;
  }

  saveChanges(value: boolean): void {
    try {
      var data = {
        game_uid: this.getGame.key,
        questData: this.questDataObject,
      };
      new QuestMapErrors(this.gameUid, this.questDataObject).checkQuestErrors();
      new QuestWarningErrors(
        this.gameUid,
        this.questDataObject,
        this.$store.state.gameStore.games
      ).checkQuestWarningErrors();
      this.$store.dispatch("questStore/updateQuest", data);
      this.showSavePanel = false;
      if (!value) {
        this.isSavedOrDiscard = true;
      }
    } catch (error) {
      console.log(error);
    }
  }
}

export default EditQuest;
